import React from "react";
import { SliderItem } from "../../../../types";
import { extractYouTubeId } from "../hooks-functions/ExtractYoutubeId";

const YOUTUBE_UI_HEIGHT = "60px";

interface CarouselPreviewMediaProps {
    item: SliderItem;
    isMobileView: boolean;
    brightness: number;
    isVideoSlide?: boolean;
}

export const CarouselPreviewMedia: React.FC<CarouselPreviewMediaProps> = ({
    item,
    isMobileView,
    brightness,
    isVideoSlide = false,
}) => {
    if (!item) return null;

    const hasVideoUrl = !!(item.videoUrl && item.videoUrl.trim());

    if (hasVideoUrl || isVideoSlide) {
        if (!hasVideoUrl) {
            return (
                <div className="no-image-placeholder">
                    <span>No video</span>
                </div>
            );
        }

        const videoId = extractYouTubeId(item.videoUrl!);

        if (!videoId) {
            return (
                <div className="no-image-placeholder">
                    <span>Invalid Video URL</span>
                </div>
            );
        }

        return (
            <div
                className="video-preview-wrapper"
                style={{
                    width: "100%",
                    height: "100%",
                    position: "relative",
                    overflow: "hidden",
                    containerType: "size",
                }}
            >
                <iframe
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&rel=0&modestbranding=1&playsinline=1`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: `max(100cqw, calc((100cqh + 2 * ${YOUTUBE_UI_HEIGHT}) * 16 / 9))`,
                        height: `max(calc(100cqh + 2 * ${YOUTUBE_UI_HEIGHT}), calc(100cqw * 9 / 16))`,
                        transform: "translate(-50%, -50%)",
                        pointerEvents: "none",
                    }}
                ></iframe>
            </div>
        );
    }

    const hasSpecificMobile = !!(item.mobile && item.mobile !== "");
    const src = isMobileView && hasSpecificMobile ? item.mobile : item.src;

    if (!src) {
        return (
            <div className="no-image-placeholder">
                <span>No image</span>
            </div>
        );
    }

    const isFallbackMobile = isMobileView && !hasSpecificMobile;

    return (
        <picture className={isFallbackMobile ? "fallback-mobile" : ""}>
            {hasSpecificMobile && (
                <source media="(max-width: 1024px)" srcSet={item.mobile} />
            )}
            <img
                className={`CarouselHome__img--desktop ${isMobileView && !hasSpecificMobile ? "mobile-src" : ""}`}
                src={src}
                alt=""
                style={{
                    filter: `brightness(${brightness}%)`,
                    objectFit: isFallbackMobile ? "cover" : "contain",
                }}
            />
        </picture>
    );
};
